import { routes, useCurrentUrl } from "../lib/urls";
import { useStepExecutions } from "./useStepExecutions";

export function useSelectedExecution(
  stepDir: string,
  workflowId: string,
  branchId: string
) {
  const { execution: urlExecutionId } = useCurrentUrl(routes.space.workflow);
  const { executions, loading } = useStepExecutions(
    workflowId,
    branchId,
    stepDir
  );
  const latest = executions[0];
  const selected = executions.find((e) => e.id === urlExecutionId) ?? latest;
  return {
    selected,
    latest,
    latestId: latest?.id,
    loading,
  };
}
